import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { SnackbarService } from './snackbar.service';
import { CustomToastComponent } from 'src/app/shared/component/custom-toast/custom-toast.component';

export interface NetworkErrorState {
  show: boolean;
  message: string;
  request?: HttpRequest<any>;
}

@Injectable({ providedIn: 'root' })
export class NetworkErrorService {
  private errorState$ = new BehaviorSubject<NetworkErrorState>({ show: false, message: '' });

  constructor(private http: HttpClient,private snackbarService: SnackbarService) {}

  get networkError$() {
    return this.errorState$.asObservable();
  }

  showNetworkErrorPopup(request: HttpRequest<any>) {
    this.errorState$.next({
      show: true,
      message:
        'The request could not be completed due to a network problem. Please try refreshing.',
      request,
    });
     const snackbarOptions: any = {
          data: {
            message: 'common_error.api-timeout-error.message',
            icon: 'close',
            action: 'close',
            color: 'red',
          },
          panelClass: 'snackbar',
        };
        // snackbarOptions['duration'] = second;
        this.snackbarService.openFromComponent(
          CustomToastComponent,
          snackbarOptions,
        );
  }

  hidePopup() {
    this.errorState$.next({ show: false, message: '' });
  }

  retryLastRequest(): void {
    const state = this.errorState$.value;
    if (state.request) {
      this.http.request(state.request).subscribe({
        next: () => this.hidePopup(),
        error: () => {
          // Keep popup open if still failing
          this.errorState$.next({
            ...state,
            message: 'Still unable to reach the server. Please try again later.',
          });
        },
      });
    }
  }
}